var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 1h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1M1 2a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2H3a2 2 0 0 1-2-2zm4 8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1v4a2 2 0 0 1-2 2zm1-7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0zm-.5 4A.5.5 0 0 1 6 7v.5a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgDuplicatesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicatesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDFIOEM4LjU1MjI4IDEgOSAxLjQ0NzcyIDkgMlY4QzkgOC41NTIyOCA4LjU1MjI5IDkgOCA5SDNDMi40NDc3MiA5IDIgOC41NTIyOSAyIDhWMkMyIDEuNDQ3NzIgMi40NDc3MiAxIDMgMVpNMSAyQzEgMC44OTU0MyAxLjg5NTQzIDAgMyAwSDhDOS4xMDQ1NyAwIDEwIDAuODk1NDMxIDEwIDJWMi45OTk5OUMxMS4xMDQ2IDIuOTk5OTkgMTIgMy44OTU0MiAxMiA0Ljk5OTk5VjkuOTk5OTlDMTIgMTEuMTA0NiAxMS4xMDQ2IDEyIDkuOTk5OTkgMTJINS45OTk5OUM0Ljg5NTQyIDEyIDMuOTk5OTkgMTEuMTA0NiAzLjk5OTk5IDEwSDNDMS44OTU0MyAxMCAxIDkuMTA0NTcgMSA4VjJaTTQuOTk5OTkgMTBDNC45OTk5OSAxMC41NTIzIDUuNDQ3NzEgMTEgNS45OTk5OSAxMUg5Ljk5OTk5QzEwLjU1MjMgMTEgMTEgMTAuNTUyMyAxMSA5Ljk5OTk5VjQuOTk5OTlDMTEgNC40NDc3MSAxMC41NTIzIDMuOTk5OTkgMTAgMy45OTk5OVY4QzEwIDkuMTA0NTcgOS4xMDQ1NyAxMCA4IDEwSDQuOTk5OTlaTTYgMi40OTk3NkM2IDIuMjIzNjEgNS43NzYxNCAxLjk5OTc2IDUuNSAxLjk5OTc2QzUuMjIzODYgMS45OTk3NiA1IDIuMjIzNjEgNSAyLjQ5OTc2VjUuNDk5NzZDNSA1Ljc3NTkgNS4yMjM4NiA1Ljk5OTc2IDUuNSA1Ljk5OTc2QzUuNzc2MTQgNS45OTk3NiA2IDUuNzc1OSA2IDUuNDk5NzZWMi40OTk3NlpNNS41IDYuNUM1Ljc3NjE0IDYuNSA2IDYuNzIzODYgNiA3VjcuNUM2IDcuNzc2MTQgNS43NzYxNCA4IDUuNSA4QzUuMjIzODYgOCA1IDcuNzc2MTQgNSA3LjVWN0M1IDYuNzIzODYgNS4yMjM4NiA2LjUgNS41IDYuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";